import { mtc } from '@/styles'
import { ReactNode } from 'react'

export enum DropdownType {
  dropdown,
}

export const InsightsDividedCard = ({
  columns,
  type,
}: {
  columns: Array<{
    content: ReactNode
    isLastColumn?: boolean
  }>
  type?: DropdownType
}) => (
  <div className="flex flex-row">
    {columns.map((config, index) => (
      <div
        className={mtc(
          type === DropdownType.dropdown ? 'p-0' : 'p-3',
          index > 0 && !config.isLastColumn ? 'ml-2 border-neutral-200' : '',
          'bg-neutral-100'
        )}
        key={index} // skipcq: JS-0437 - Ignoring deepsource since there's no candidate identifier to access
      >
        {config.content}
      </div>
    ))}
  </div>
)
